import { SignInAPI } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export enum OAuthProviderType {
  GOOGLE = 'GOOGLE',
  KAKAO = 'KAKAO',
  NAVER = 'NAVER',
}

export function parseOAuthProviderType(provider: string): OAuthProviderType {
  switch (provider.toLowerCase()) {
    case 'google':
      return OAuthProviderType.GOOGLE;
    case 'kakao':
      return OAuthProviderType.KAKAO;
    case 'naver':
      return OAuthProviderType.NAVER;
    default:
      throw new Error(`Unsupported provider: ${provider}`);
  }
}

interface MaybeSignInRequest {
  providerType: OAuthProviderType;
  authorizationCode: string;
  redirectUri: string;
  isMobile: boolean;
  mobileInvitationToken?: string;
}

type MaybeSignInResponse = ResponseBaseWithData<{
  signIn?: {
    token: string;
  };
  signUpRequired?: {
    email?: string;
    name?: string;
    phone?: string;
    oauthConnectionToken: string;
  };
}>;

const maybeSignInWithOAuth = async (payload: MaybeSignInRequest) => {
  return await SignInAPI.post<MaybeSignInResponse>('/api/v1/oauth/maybe-sign-in', {
    data: {
      ...payload,
    },
  });
};

export default maybeSignInWithOAuth;
